import { render, staticRenderFns } from "./ReactivateModal.vue?vue&type=template&id=252ddeb2&scoped=true&"
import script from "./ReactivateModal.vue?vue&type=script&lang=js&"
export * from "./ReactivateModal.vue?vue&type=script&lang=js&"
import style0 from "./ReactivateModal.vue?vue&type=style&index=0&id=252ddeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252ddeb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('252ddeb2')) {
      api.createRecord('252ddeb2', component.options)
    } else {
      api.reload('252ddeb2', component.options)
    }
    module.hot.accept("./ReactivateModal.vue?vue&type=template&id=252ddeb2&scoped=true&", function () {
      api.rerender('252ddeb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReactivateModal.vue"
export default component.exports